<template>
    <v-container>
        <v-row v-if="isLoading" class="mb-4">
            <v-col class="mb-5" cols="12">
                <h2 class="headline font-weight-bold mb-3">
                    <v-skeleton-loader type="heading"></v-skeleton-loader>
                </h2>
                <v-spacer></v-spacer>
                <v-skeleton-loader type="text"></v-skeleton-loader>
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="6" lg="4">
                <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="6" lg="4">
                <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-col>
        </v-row>

        <v-row class="text-center">
            <v-col class="mb-5" cols="12">
                <h2 class="headline font-weight-bold mb-3">
                    {{stock.Title}}&nbsp;{{stock.Subtitle}}
                </h2>
                <v-spacer></v-spacer>
                {{stock.HasStock ? (stock.ShowPrice ? stock.Price : "ASK") : "Sold"}}
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="(image, i) in stock.Images" :key="i" cols="12" md="6" lg="4">
                <v-card :href="image.ImageUrl">
                    <v-img v-if="!image.IsMovie" :src="image.ImageUrl" max-height="350"></v-img>
                    <iframe v-if="image.IsMovie" :src="image.ImageUrl" width="100%" height="350"></iframe>
                    <v-card-title v-if="image.Title">{{image.Title}}</v-card-title>
                    <v-card-text v-if="image.Description">{{image.Description}}</v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
  
<script>
export default {
    name: 'StockDetail',

    data: () => ({
        isActive: false,
        isLoading: true,
        stock: {},
    }),
    mounted() {
        fetch(`/api/stock/${this.$route.params.id}`).then(res => {
            return res.json();
        }).then(data => {
            console.log(data)
            this.isLoading = false;
            this.stock = data;
        });
    }
}
</script>
  